import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/core/api.service';
import { FileItemService } from '../file-item.service';
import { TransferService } from 'src/app/transfer/services/transfer.service';
import { IErrorCode, IFile, IHistoryItem } from 'src/sync';
import { CellTypes, Column, Pagination, DialogConfig } from '@material-library';
import { PageEvent } from '@angular/material/paginator';
import { Base64Service } from 'src/app/core/base64.service';
import { BytesToSizePipe } from 'src/app/shared/pipes/bytes-to-size.pipe';
import { ShareService } from 'src/app/shared/services/share.service';
import { BlendEvent, User } from 'src/app/shared/models';
import { SkuService } from 'src/app/shared/services/sku.service';
import { UserService } from 'src/app/core/user.service';
import { FileListService } from 'src/app/file-list/services/file-list.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { PaginationComponent } from '@material-library';
import { RootLayoutConfigService } from 'src/app/shared/layout/root-layout/root-layout-config.service';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { BlendService } from 'src/app/shared/services/blend.service';
import { cAccountInfo } from "../../shared/models/api/chargbeeprofile-api.model";
import { ChargebeeService } from "../../shared/services/chargebee.service";

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('syncPagination') syncPaginator!: PaginationComponent;
  @ViewChild('nameTemplate') nameTemplateRef: TemplateRef<any>;

  public dataInChunk: IHistoryItem[] = [];
  public alerts: IErrorCode[] = [];
  public success = false;
  public currentItem: IFile;
  public isReadOnly = false;

  public syncId: number;
  public histId = 0;
  public maxLimit: number= 1000;
  public isLoading: boolean = false;

  fistHistId: number = 0;

  public versionHistoryPaginationConfig: Pagination;
  public pageObj = {
    pageIndex: 0,
    pageSize: 50,
    previousPageIndex: 0,
    length: 0,
  };

  public dataListColumns: Column[] = [];
  public versionHistoryDataSource: IHistoryItem[] = [];
  public totalItems: number;

  private bytesToSizePipe: BytesToSizePipe = new BytesToSizePipe();
  iconName: string = '';
  public limit: number;
  public chargebeeProfile: cAccountInfo;
  public showUpgradeButton: boolean = false;
  public planName: string;
  public user: User;
  @ViewChild('avatarItemRef') avatarItemRef: TemplateRef<any>;
  isFileViewable:boolean = true;
  public hasMore: boolean;
  public isLoadMoreLoading: boolean = false;
  setLoadedPageIndex = [0];

  onActionClick = async () => {
  }
  public subTitle:string = '';
  public closeIconName: "close" | "arrow-left" = 'close';
  showDialog: boolean = false;
  public previewOldItem:IFile;
  public previewHistoryItem:IHistoryItem;
  public type: string;
  public dialogConfig:DialogConfig;
  public showRestoreDialog:boolean = false;
  public isSmallScreen: boolean = false;
  private breakpointSubscriptions: Subscription[] = [];
  private chargebeeSubscription: Subscription;
  public hasNextPage: 0 | 1;

  constructor(
    private apiService: ApiService,
    private fileItemService: FileItemService,
    private transferService: TransferService,
    private shareService: ShareService,
    private route: ActivatedRoute,
    private chargebeeService: ChargebeeService,
    private skuService: SkuService,
    public userService: UserService,
    private router: Router,
    public fileListService: FileListService,
    public base64Service: Base64Service,
    public snackbarService: SnackbarService,
    public breakpointObserver: BreakpointObserver,
    private rootLayoutConfigService: RootLayoutConfigService,
    private location: Location,
    private blendService: BlendService
  ) { }

  async ngOnInit() {
    this.hasMore = true;
    this.setLoadedPageIndex = [this.histId];
    this.breakpointSubscriptions.push(this.breakpointObserver
      .observe(['(min-width: 905px) and (max-width: 1239px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.rootLayoutConfigService.updateConfig({
            isCustomLayout: true,
            appBar: {
              showLeadIcon: true,
              prominent: true,
              leadIcon: { iconName: 'arrow-left', disabled: false, size: 'large' },
              heading: 'Version history',
              onLeadIconClick: () => {
                this.location.back();
              }
            }
          })
        }
        else {
          this.rootLayoutConfigService.updateConfig({
            isCustomLayout: true,
            appBar: {
              prominent: true,
              showBreadcrumb: true,
              isBreadcrumb: {
                items: [
                  {
                    label: 'Version history',
                    url: false,
                  },
                ]
              },
              onBackClick: () => {
                this.location.back();
              }
            }
          })
        }
      }));

    this.breakpointSubscriptions.push(this.breakpointObserver
      .observe(['(max-width: 904px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isSmallScreen = true;
        }else{
          this.isSmallScreen = false;
        }
      }));
    this.initStaticData();
    this.syncId = this.route.snapshot.params['id'];
    this.versionHistoryDataSource = [];
    await this.getCurrentItem()
    this.user = this.userService.getUser();
    await this.getAccountDetails()
    this.iconName = this.fileItemService.getFileTypeIcon(this.currentItem);
    this.isReadOnly = this.currentItem.is_readonly > 0;
    this.type = this.fileItemService.previewFileType(this.currentItem);
    this.dataInChunk = [];
    this.versionHistoryDataSource = [];
    await this.getHistory();
    this.pageObj.pageIndex = 0;
    this.dataListColumns.find(c => c.key == 'event_username').templateRef = this.nameTemplateRef;
  }

  ngOnDestroy() {
    this.rootLayoutConfigService.updateConfig(null);
    for (const subscription of this.breakpointSubscriptions) {
        subscription?.unsubscribe();
    }
    this.chargebeeSubscription?.unsubscribe();
  }

  async getAccountDetails() {
    this.user = this.userService.getUser();
    this.planName = this.user.plan_name;
    this.limit = await this.skuService.getDataLimit();
    if (await this.skuService.isFreeUser()) {
      this.planName = 'Free plan'
    } else {
      this.showUpgradeButton = this.limit !== 365;
      await new Promise((resolve) => {
        this.chargebeeSubscription = this.chargebeeService.getSubscription().subscribe(data => {
          if (data.isLoaded) {
            this.chargebeeProfile = data.cprofile;
            resolve(true);
          }
        });
      });
      if (this.chargebeeProfile?.subscription) {
        this.planName = this.chargebeeProfile.subscription?.planName
      }
    }
  }
  ngAfterViewInit(): void {
    this.dataListColumns[0].templateRef = this.avatarItemRef;
    this.dataListColumns.find(c => c.key == 'event_username').templateRef = this.nameTemplateRef;
    this.dataListColumns = [...this.dataListColumns];
  }
  initStaticData() {
    this.fistHistId = 0;
    this.versionHistoryPaginationConfig = {
      length: 0,
      pageSize: 50,
      alignment: 'right',
      onPageChange: async (event: PageEvent) => {
        await this.handlePageChange(event)
      },
    };
    this.pageObj = {
      pageIndex: 0,
      pageSize: 50,
      previousPageIndex: 0,
      length: 0,
    };
    this.dataListColumns = [
      {
        key: 'icon',
        header: '',
        type: CellTypes.templateRef,
        templateRef: this.avatarItemRef,
        width: '48px',
        visibleMaxWidth: 905 - 32,
      },
      {
        key: 'event_username',
        header: 'Name',
        subTextKey: 'description',
        isPrimary: true,
        type: CellTypes.templateRef,
        visibleMaxWidth: 600 - 32,
        cell: (e: IHistoryItem) => {
          return {
            value: this.currentItem.name,
            subText: `${e['action_text']} by ${e.event_username} ${e.event_device_name ? '(' + e.event_device_name + ')' : ''}`,
            overlineText: ``,
          };
        },
      },
      {
        key: 'date',
        header: 'Modified',
        type: CellTypes.text,
        isSecondary: true,
        width: '170px',
        isSortable: true,
        cell: (element: IHistoryItem) => {
          return {
            value: this.shareService.formatTimestamp(element['date'])
          }
        },
        sort: (isSortAsc: boolean) => {
          this.sortList('date', isSortAsc);
        }
      },
      {
        key: 'size',
        width: '92px',
        header: 'Size',
        type: CellTypes.text,
        visibleMaxWidth: 905 - 32,
        cell: (element: IHistoryItem) => this.bytesToSizePipe.transform(element['size']),
      },
      {
        key: 'hist_id',
        width: '130px',
        header: 'Actions',
        type: CellTypes.action,
        isAlignRight: true,
        actionLimit: 2,
        shouldDisable: (e: IHistoryItem) => {
          const isFirst = this.fistHistId === e.hist_id;
          const isSameVersion = e.blob_id === this.currentItem.blob_id;
          return !isFirst && isSameVersion;
        },
        plainTextConfig: (e: IHistoryItem) => {
          const isFirst = this.fistHistId === e.hist_id;
          const isSameVersion = e.blob_id === this.currentItem.blob_id;
          return {
            showPlainText: !isFirst && isSameVersion,
            value: 'Same as current'
          }
        },
        chipConfig: (e: IHistoryItem) => {
          const isFirst = this.fistHistId === e.hist_id;
          return {
            showChip: isFirst,
            value: 'Current version'
          }
        },
        actions: [
          {
            name: 'Restore',
            icon: 'restore',
            onClick: (historyItem: IHistoryItem) => {
              this.restoreVersion(historyItem.blob_id)
            },
            shouldShow: (historyItem) => {
              const isFirst = this.fistHistId === historyItem.hist_id;
              return !this.isReadOnly && !isFirst && historyItem.blob_id != this.currentItem.blob_id
            },
          },
          {
            name: 'View file',
            icon: 'preview',
            onClick: (historyItem: IHistoryItem) => {
              historyItem = { ...historyItem };
              for (const key in historyItem) {
                if (historyItem[key] === null || historyItem[key] === undefined) {
                  delete historyItem[key];
                }
              }
              const item:IFile = { ...this.currentItem, ...historyItem,cachekey: historyItem.cachekey, blob_id: historyItem.blob_id }
              this.openVersionHistoryPreviewDialog(item,historyItem);
            },
            shouldShow: (historyItem) => {
              return !this.isReadOnly && historyItem.blob_id != this.currentItem.blob_id
            },
            divider: true,
            description: !this.isFileViewable,
            descriptionContent:'File type not supported',
            isDisabled:()=>!this.isFileViewable
          },
          {
            name: 'Download',
            icon: 'download',
            onClick: (historyItem: IHistoryItem) => {
              this.download(historyItem)
            },
            shouldShow: (historyItem) => {
              return !this.isReadOnly && historyItem.blob_id != this.currentItem.blob_id
            },
          },
        ],
      }
    ];
  }
  handlePageChange = async (event: PageEvent) => {
    if(!this.setLoadedPageIndex.includes(event.pageIndex)){
      this.setLoadedPageIndex.push (event.pageIndex);
        // await this.getHistory();
      console.log('handlePageChange call next',this.versionHistoryDataSource,this.hasNextPage);
    }
    const currentPage = event.pageIndex + 1;
    const itemsPerPage = event.pageSize;
    const previousPageIndex = currentPage > 1 ? currentPage - 1 : 0;

    const startIndex =
      (currentPage == 0 ? currentPage : currentPage - 1) * itemsPerPage;
    let endIndex = startIndex + itemsPerPage;

    const filteredData = [...this.versionHistoryDataSource];
    this.pageObj = {
      pageIndex: currentPage,
      pageSize: itemsPerPage,
      previousPageIndex: previousPageIndex,
      length: filteredData.length,
    };


    if (endIndex > filteredData.length) {
      endIndex = filteredData.length;
    }
    this.versionHistoryPaginationConfig.length = filteredData.length;
    // this.dataInChunk = [];
    // this.dataInChunk = [...filteredData.slice(startIndex, endIndex)];
    // this.versionHistoryPaginationConfig = { ...this.versionHistoryPaginationConfig }
  }


  public pathGet = (sync_id: number) => {
    return this.apiService.execute('pathget', {
      sync_id: sync_id,
    });
  }

  restoreVersion(blobId: number) {
    this.success = false;
    this.restoreVersionApi(this.syncId, blobId).then(
      async (data) => {
        await this.getCurrentItem();
        this.alerts = [];
        this.histId = 0;
        this.snackbarService.showMessage('success', 'Successfully restored version')
        this.dataInChunk = [];
        this.versionHistoryDataSource = [];
        this.blendService.track(BlendEvent.RESTORE_VERSION, {
          file_size: this.currentItem.size,
          file_type: this.currentItem.type,
          file_id: this.currentItem.id,
          file_version: this.currentItem.version,
          file_version_history_count: this.versionHistoryDataSource.length,
        })
        await this.getHistory();
        this.pageObj.pageIndex = 0;
        this.handlePageChange(this.pageObj);
        this.success = true;
      },
      (err) => {
        if (typeof err === 'object' && err.error_code) {
          this.alerts.push({
            code: err.error_code,
            msg: err.error_msg,
          });

        } else {
          this.alerts.push({
            code: 1000,
            msg: 'Error restoring the version history',
          });

        }
        this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
      }
    );
  }
  public restoreVersionApi(syncId: number, blobId: number) {
    return this.apiService.execute('restorewebversion', {
      sync_id: syncId,
      version_id: blobId,
    });
  }
  getHistory = async () => {
    if (this.isLoadMoreLoading) return;
    this.isLoadMoreLoading = true;
    this.isLoading = false;
    const result = await this.getHistoryApi(this.syncId, this.histId);
    if (result.events.length) {
      const data = result.events.map((e) => {
        return { ...e, event_username: this.base64Service.decode(e.event_username), event_device_name: this.base64Service.decode(e.event_device_name) }
      }).sort((a, b) => b.date - a.date);
      if (!this.histId) {
        this.fistHistId = data[0].hist_id;
      }
      // this.versionHistoryDataSource = [];
      this.histId = result.hist_id;
      this.totalItems = this.versionHistoryDataSource.length;
      this.dataInChunk = [...this.dataInChunk, ...data]
      this.versionHistoryDataSource = [...this.versionHistoryDataSource, ...data];
      // this.handlePageChange(this.pageObj);
      if(data.length !== 50){
        this.hasMore = false;
      }
    } else {
      this.hasMore = false;
    }
    this.isLoading = false;
    this.isLoadMoreLoading = false;
  }


  public getHistoryApi = async (syncId: number, histId: number = 0): Promise<any> => {
    const response = await this.historyApi(syncId, histId);
    response.events = this.decorate(response.events);
    return response;
  }

  public historyApi=(sync_id: number, hist_id: number): Promise<any> =>{
    return this.apiService.execute('pathhistory', {
      sync_id: sync_id,
      hist_id: hist_id,
      limit:this.maxLimit
    });
  }

  public decorate=(events: IHistoryItem[]): IHistoryItem[]=> {
    let i,
      len,
      action,
      curEvent: IHistoryItem,
      lastEvent;
    const retEvents = [],
      prevEvents: { [key: number]: IHistoryItem } = {};
    for (i = 0, len = events.length; i < len; i++) {
      action = undefined;
      curEvent = events[i];
      lastEvent = prevEvents[curEvent.sync_id];

      if (!curEvent) {
        continue;
      }

      // don't duplicate rows in the path history
      if (
        lastEvent &&
        lastEvent.blob_id == curEvent.blob_id &&
        lastEvent.event_type == curEvent.event_type &&
        lastEvent.size == curEvent.size
      ) {
        continue;
      }
      switch (parseInt(curEvent.event_type, 10)) {
        case -2:
          action = 'Purged';
          break;
        case -1:
          action = 'Deleted';
          break;
        case 0:
          action = 'Pending';
          break;
        case 1:
          action = 'Added';
          break;
        case 2:
          action = 'Restored';
          break;
        case 3:
          action = 'Edited';
          break;
        default:
          action = '';
      }
      curEvent.action_text = action;
      prevEvents[curEvent.sync_id] = curEvent;
      retEvents.push(curEvent);
    }
    return retEvents;
  }
  download(eventRow: IHistoryItem) {
    eventRow.spinner = true;
    const dlVersion = Object.assign({}, this.currentItem);
    dlVersion.cachekey = eventRow.cachekey;
    dlVersion.blob_id = eventRow.blob_id;
    dlVersion.size = eventRow.size;

    dlVersion.blobtype = 'btFILE';

    for (const key in eventRow) {
      if (eventRow.hasOwnProperty(key)) {
        dlVersion[key] = eventRow[key];
      }
    }
    this.transferService.queueDownload([dlVersion]);
  }

  onViewFileClick = (data: IFile) => {
    this.router.navigate([this.fileListService.getItemLink(data)]);
  }
  onViewButtonClick: () => void = () => {
    this.onViewFileClick(this.currentItem)
  };

  onCancelDialogClick = ()=>{
    this.showDialog = false;
    this.previewOldItem = undefined;
  }

  closeDialog = () => {
    this.showRestoreDialog = false
  }

  openVersionHistoryPreviewDialog = (previewOldItem:IFile,previewHistoryItem:IHistoryItem) =>{
    this.subTitle = this.shareService.formatTimestamp(previewHistoryItem['date'])

    this.dialogConfig = {
      title: 'View file',
      subTitle: this.subTitle,
      isClosable: true,
      closeIcon: this.closeIconName,
      onCloseIcon: this.onCancelDialogClick,
      actionButton: '',
      cancelButton: 'Close',
      onCancelClick: this.onCancelDialogClick,
      titleActionButtonConfig:[{
      iconName: 'restore',
      type: 'primary',
      size: 'small',
      name: 'Restore',
      onClick: (event:any) => {
        this.showDialog = false;
        this.showRestoreDialog = true;
      }},
      {
        iconName: 'download',
        type: 'primary',
        size: 'small',
        name: 'Download',
        onClick: (event:any) => this.download(previewHistoryItem)
      }]
    }

    this.showDialog = true;
    this.previewOldItem = previewOldItem;
    this.previewHistoryItem = previewHistoryItem;
  }

  onRestoreDialogClick = () => {
    this.restoreVersion(this.previewHistoryItem.blob_id);
    this.closeDialog();
  }

  onRestoreClick = () => {
    this.restoreVersion(this.currentItem.blob_id);
  }
  sortList = (key, isSortAsc)=>{
    this.versionHistoryDataSource = this.versionHistoryDataSource.sort((a, b) => {
      if (isSortAsc) {
        return a[key] > b[key] ? 1 : -1;
      } else {
        return a[key] < b[key] ? 1 : -1;
      }
    });
    if(this.syncPaginator && this.syncPaginator?.paginator){
      this.syncPaginator.paginator?.firstPage()
    }
    this.pageObj.pageIndex = 0;
    this.handlePageChange(this.pageObj);
  }

   getCurrentItem=async()=> {
    const data = await this.pathGet(this.syncId);
    this.currentItem = await this.fileItemService.format(data);
    const fileViewable = this.fileItemService.getFileTypeData(this.currentItem.name);
    this.isFileViewable = fileViewable.viewable;
    if(['mime-audio','mime-video'].includes(fileViewable.cssclass)){
      this.isFileViewable = true;
    }
    this.dataListColumns[4].actions[1].description = !this.isFileViewable;
  }

  get countText() {
    return typeof this.totalItems === 'undefined' ? ' ' : (this.totalItems + ' version' + (this.totalItems === 1 ? '' : 's'))
  }
}
